/**
****************************************************
***                        *******    ******    ****
***                        ******    ******    *****
***********       **************    ******    ******
***********       *************    ******    *******
***********       ************    ******    ********
***********       ***********    ******    *********
***********       **********    ******    **********
***********       *********    ******    ***********
***********       ********    ******    ************
***********       *******    ******    *************
***********       ******    ******    **************
****************************************************
* --------------------------------------------------
* Travlr UiKit: index.js
* By Travlr Team
* --------------------------------------------------
*/

import Button from './button'
import Modal from './modal'
import Dropdown from './dropdown'
import Notification from './notification'

export default {
  button: Button,
  modal: Modal,
  dropdown: Dropdown,
  notification: Notification
}
